import { INDICATOR_TYPE } from "../../data/dummy-data";

const getLabelById = (id) => {
  const indicator = INDICATOR_TYPE.find((item) => item.id === id);
  return indicator ? indicator.label : null; // Returns null if no match is found
};

const FORM_INPUTE_COLUMNS = [
  {
    field: "label",
    headerName: "Indikator",
    width: 250,
    flex: 1,
    editable: false,
  },
  {
    field: "type",
    headerName: "Tipi",
    width: 250,
    flex: 1,
    editable: false,
    renderCell: (params) =>
      !params.row.type ? "" : getLabelById(params.row.type),
  },
  {
    field: "unit",
    headerName: "Njësia matëse",
    width: 200,
    flex: 1,
    editable: false,
  },
  {
    field: "order",
    headerName: "Rendi",
    width: 100,
    flex: 1,
    editable: false,
  },
];

export default FORM_INPUTE_COLUMNS;
